module.exports = __webpack_public_path__ + "img/cn.d1fdc3cc.svg";